import React from 'react';
import {
  MessageSquare,
  Trash2,
  Plus,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';

const ConversationSidebar = ({
  conversations,
  activeConversation,
  onSelectConversation,
  onDeleteConversation,
  onNewConversation,
  isCollapsed,
  onToggleCollapse
}) => {
  return (
    <div className={`bg-white border-r border-gray-200 transition-all duration-300 flex-shrink-0 ${
      isCollapsed ? 'w-0 border-0' : 'w-64'
    } max-lg:absolute max-lg:left-0 max-lg:top-0 max-lg:h-full max-lg:z-30 max-lg:shadow-lg ${
      isCollapsed ? 'max-lg:w-0' : 'max-lg:w-60'
    } overflow-hidden`}>
      <div className="h-full flex flex-col w-64">
        {/* Header */}
        <div className="p-3 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-base font-semibold text-gray-900">Chat History</h2>
          <button
            onClick={onToggleCollapse}
            className="p-1.5 hover:bg-gray-100 rounded transition-colors"
            aria-label="Collapse sidebar"
            title="Hide history"
          >
            <ChevronLeft className="w-4 h-4 text-gray-600" />
          </button>
        </div>

        <>
          {/* New Conversation Button */}
          <div className="p-3">
            <button
              onClick={onNewConversation}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 text-white rounded-lg transition-colors text-sm font-medium"
              style={{ backgroundColor: '#1C4645' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.color = '#1C4645';
                e.currentTarget.style.border = '1px solid #1C4645';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#1C4645';
                e.currentTarget.style.color = '#ffffff';
                e.currentTarget.style.border = 'none';
              }}
            >
              <Plus className="w-4 h-4" />
              New Chat
            </button>
          </div>

          {/* Conversations List */}
          <div className="flex-1 overflow-y-auto">
            {conversations.length === 0 ? (
              <div className="p-4 text-center text-gray-500 text-xs">
                <MessageSquare className="w-6 h-6 mx-auto mb-2 text-gray-400" />
                <p>No history yet</p>
                <p className="text-xs mt-1 text-gray-400">Start chatting to begin</p>
              </div>
            ) : (
              <div className="space-y-1 p-2">
                {conversations.map((conversation) => {
                  const isActive = activeConversation === conversation.id;
                  return (
                    <div
                      key={conversation.id}
                      className={`group flex items-start gap-2 p-2 rounded cursor-pointer transition-all ${
                        isActive
                          ? 'border'
                          : 'hover:bg-gray-50'
                      }`}
                      style={isActive ? {
                        backgroundColor: '#f0f9ff',
                        borderColor: '#1C4645'
                      } : {}}
                      onClick={() => onSelectConversation(conversation.id)}
                    >
                      <MessageSquare className="w-3.5 h-3.5 text-gray-400 flex-shrink-0 mt-0.5" />
                      <div className="flex-1 min-w-0">
                        <p className={`text-xs font-medium truncate ${
                          isActive ? 'text-gray-900' : 'text-gray-700'
                        }`}>
                          {conversation.title}
                        </p>
                        <p className="text-xs text-gray-500">
                          {conversation.timestamp.toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric'
                          })}
                        </p>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm('Delete this conversation?')) {
                            onDeleteConversation(conversation.id);
                          }
                        }}
                        className="opacity-0 group-hover:opacity-100 p-1 hover:bg-red-100 rounded transition-all"
                        aria-label="Delete conversation"
                      >
                        <Trash2 className="w-3 h-3 text-red-500" />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Storage Info Footer */}
          <div className="p-7 border-t border-gray-200 bg-gray-50 rounded-xl">
            <p className="text-xs text-gray-500 text-center">
              {conversations.length} / 15 saved
            </p>
          </div>
        </>
      </div>
    </div>
  );
};

export default ConversationSidebar;
